import React from 'react'
import { Link } from 'react-router-dom'

const HomePage = props => {
  return (
    <div>
      <div className='container mt-5'>
        <div className='row'>
          <div className='col-lg-5'>
            <Link to='/apm/registration'>
              <div className='card rounded bg-white'>
                <div className='card-body  text-center'>
                  <h1 className='card-title display-4 text-warning'>
                    ANTRIAN PENDAFTARAN
                  </h1>
                  <img
                    src='./assets/img/icons/health/iconfinder_50_3678411.svg'
                    alt=''
                    height='200px'
                  />
                  <div className='card-text mt-3'>
                    <h1 className='text-darker'>Pendaftaran</h1>
                    <h2 className='text-grey'>
                      Untuk pasien yang belum terdaftar pelayanan puskesmas
                    </h2>
                  </div>
                </div>
              </div>
            </Link>
          </div>
          <div className='col-lg-5 ml-auto'>
            <Link to='/apm/search'>
              <div className='card rounded bg-white'>
                <div className='card-body text-center'>
                  <h2 className='card-title display-4 text-success'>
                    ANTRIAN POLI
                  </h2>
                  <img
                    src='./assets/img/icons/health/iconfinder_50_3678411.svg'
                    alt=''
                    height='200px'
                  />
                  <div className='card-text mt-3'>
                    <h1 className='text-darker'>Poli</h1>
                    <h2 className='text-grey'>
                      Untuk pasien yang sudah terdaftar pelayanan puskesmas
                    </h2>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;